import React, { useState } from 'react'
import { useTimer } from 'react-timer-hook'
import { Dialog } from '~/components'
import {
  AddressModal,
  UpdateInfoModal,
  ValidateInfoModal,
  SuccessValidationModal,
  SocialNetworkInfoModal
} from '../'
import { AccountPendenciesCachedData, MODAL_TYPE, CashedDataPayload } from '../..'

const RESEND_TIME_MS = 10000

export interface ModalControllerProps {
  isVisible: boolean,
  toggleModal: () => void,
  openedModalType: MODAL_TYPE,
  cachedData: AccountPendenciesCachedData,
  setOpenedModalType: (modalType: MODAL_TYPE) => void,
  modifyCachedData: (key: keyof AccountPendenciesCachedData, payload: CashedDataPayload) => void
}

export const ModalController: React.FC<ModalControllerProps> = (props) => {
  const { isVisible, toggleModal, openedModalType, setOpenedModalType, modifyCachedData, cachedData } = props
  const [canResend, setCanResend] = useState(true)

  const { seconds, restart } = useTimer({
    expiryTimestamp: new Date().getTime() + RESEND_TIME_MS,
    onExpire: () => {
      setCanResend(true)
    }
  })

  const getModal = () => {
    if (openedModalType === MODAL_TYPE.SuccessValidationEmailModal || openedModalType === MODAL_TYPE.SuccessValidationPhoneModal) {
      return (
        <SuccessValidationModal
          toggleModal={toggleModal}
          setOpenedModalType={setOpenedModalType}
          isEmail={openedModalType === MODAL_TYPE.SuccessValidationEmailModal}
        />
      )
    }
    if (openedModalType === MODAL_TYPE.AddressModal) {
      return (
        <AddressModal
          cachedData={cachedData}
          toggleModal={toggleModal}
          modifyCachedData={modifyCachedData}
          setOpenedModalType={setOpenedModalType}
        />
      )
    }
    if (openedModalType === MODAL_TYPE.ValidateEmailModal || openedModalType === MODAL_TYPE.ValidatePhoneModal) {
      return (
        <ValidateInfoModal
          seconds={seconds}
          restart={restart}
          canResend={canResend}
          cachedData={cachedData}
          setCanResend={setCanResend}
          modifyCachedData={modifyCachedData}
          setOpenedModalType={setOpenedModalType}
          isEmail={openedModalType === MODAL_TYPE.ValidateEmailModal}
        />
      )
    }
    if (openedModalType === MODAL_TYPE.UpdateEmailModal || openedModalType === MODAL_TYPE.UpdatePhoneModal) {
      return (
        <UpdateInfoModal
          cachedData={cachedData}
          toggleModal={toggleModal}
          modifyCachedData={modifyCachedData}
          setOpenedModalType={setOpenedModalType}
          isEmail={openedModalType === MODAL_TYPE.UpdateEmailModal}
        />
      )
    }
    if (openedModalType === MODAL_TYPE.SocialNetworkInfoModal) {
      return (
        <SocialNetworkInfoModal
          cachedData={cachedData}
          toggleModal={toggleModal}
          modifyCachedData={modifyCachedData}
          setOpenedModalType={setOpenedModalType}
        />
      )
    }
  }

  return (
    <>
      <Dialog
        isVisible={isVisible}
        onClose={toggleModal}
      >
        {getModal()}
      </Dialog>
    </>
  )
}
